import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';

import type { LC_AsyncJobListOut, LC_AsyncJobTypeOut, LC_ListAsyncJobsIn } from './types';


export class AsyncJobService {
  async listJobs(
    params: LC_ListAsyncJobsIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_AsyncJobListOut>> {
    const queryString = buildQueryString({ ...params });
    return apiClient.get<LC_AsyncJobListOut>(
      `${API_CONFIG.ENDPOINTS.ASYNC_JOBS.LIST}${queryString}`,
      { signal },
    );
  }

  async getTypes(signal?: AbortSignal): Promise<ApiResponse<LC_AsyncJobTypeOut[]>> {
    return apiClient.get<LC_AsyncJobTypeOut[]>(
      API_CONFIG.ENDPOINTS.ASYNC_JOBS.TYPES,
      { signal },
    );
  }

  async downloadJob(
    id: string,
    signal?: AbortSignal,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    return apiClient.downloadBlobWithFilename(
      API_CONFIG.ENDPOINTS.ASYNC_JOBS.DOWNLOAD(id),
      { method: 'GET', signal },
    );
  }
}

export const asyncJobService = new AsyncJobService();
